import { useResponsiveProp } from '@telus-uds/components-base';
const getContentStackDirection = fullBleedContentPosition => {
  switch (fullBleedContentPosition) {
    case 'left':
      return 'row-reverse';
    case 'right':
      return 'row';
    case 'top':
      return 'column-reverse';
    default:
      return 'column';
  }
};
const getContentStackAlign = fullBleedContentAlign => {
  switch (fullBleedContentAlign) {
    case 'center':
      return 'center';
    case 'end':
    case 'flex-end':
      return 'flex-end';
    case 'start':
    case 'flex-start':
      return 'flex-start';
    default:
      return 'stretch';
  }
};

/**
 * Resolves a set of `FullBleedContent` props into the variables a container needs to
 * correctly position a `FullBleedContent` component for the current viewport.
 *
 * @param {object} [fullBleedContent] - a set of valid proptypes for FullBleedContent
 * @returns
 */
const useFullBleedContentProps = fullBleedContent => {
  const {
    align: fullBleedContentAlignProp,
    position: fullBleedContentPositionProp,
    contentAlign: fullBleedContentChildrenAlignProp,
    ...fullBleedContentProps
  } = fullBleedContent ?? {
    position: 'none'
  };
  const fullBleedContentPosition = useResponsiveProp(fullBleedContentPositionProp, 'none');
  const contentStackDirection = getContentStackDirection(fullBleedContentPosition);
  const fullBleedContentAlign = useResponsiveProp(fullBleedContentAlignProp, 'stretch');
  const contentStackAlign = getContentStackAlign(fullBleedContentAlign);
  const fullBleedContentChildrenAlign = useResponsiveProp(fullBleedContentChildrenAlignProp, 'stretch');
  return {
    contentStackAlign,
    contentStackDirection,
    fullBleedContentPosition,
    fullBleedContentProps,
    fullBleedContentChildrenAlign
  };
};
export default useFullBleedContentProps;